import CategoryIcon from '@mui/icons-material/Category';
import { Alert, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

import { CustomAccordion } from '../../../components/CustomAccordion';
import { type Veranstaltung } from '../../../dtos';

type VeranstaltungsAusstattungRefProps = {
  readonly veranstaltung: Veranstaltung;
};

export const VeranstaltungsAusstattungRefComponent = ({ veranstaltung }: VeranstaltungsAusstattungRefProps) => (
  <CustomAccordion title="Ausstattung Referent" open={false} icon={CategoryIcon}>
    {veranstaltung.referentMaterial.length === 0 ? (
      <Alert severity="info">Kein Referenten-Material vorhanden</Alert>
    ) : (
      <TableContainer component={Box}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ 'td, th': { padding: 0, paddingRight: '4px', paddingLeft: '4px', paddingBottom: '2px' } }}>
              <TableCell>ID</TableCell>
              <TableCell>Materialbezeichung</TableCell>
              <TableCell>Anzahl</TableCell>
              <TableCell>Zuständig</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {veranstaltung.referentMaterial.map((ausstattung) => (
              <TableRow
                key={ausstattung.id}
                sx={{
                  'td, th': {
                    border: 0,
                    padding: 0,
                    paddingRight: '4px',
                    paddingLeft: '4px',
                    paddingBottom: '2px',
                    verticalAlign: 'top',
                  },
                }}
              >
                <TableCell>{ausstattung.id}</TableCell>
                <TableCell>{ausstattung.bezeichnung}</TableCell>
                <TableCell>{ausstattung.anzahl}</TableCell>
                <TableCell>{ausstattung.zustaendigkeit}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    )}
  </CustomAccordion>
);
